(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-specs"] && !Shopify.designMode) return;
  try {
    class PdpTabs extends HTMLElement {
    connectedCallback() {
      document.documentElement.classList.add('js-enhanced');
      this._ac = new AbortController();
      const opts = { signal: this._ac.signal };
      this._tabs   = Array.from(this.querySelectorAll('[role="tab"]'));
      this._panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this._tabs.length === 0) return;
      this._showTab(0);
      this._tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this._showTab(i), opts);
        tab.addEventListener('keydown', (e) => this._handleKey(e, i), opts);
      });
    }
    disconnectedCallback() { if (this._ac) this._ac.abort(); }
    _showTab(activeIndex) {
      this._tabs.forEach((tab, i) => {
        const isActive = i === activeIndex;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      this._panels.forEach((panel, i) => { panel.hidden = i !== activeIndex; });
    }
    _handleKey(e, i) {
      const count = this._tabs.length;
      if (e.key === 'ArrowRight') { e.preventDefault(); this._tabs[(i + 1) % count].focus(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this._tabs[(i - 1 + count) % count].focus(); }
      if (e.key === 'Home')       { e.preventDefault(); this._tabs[0].focus(); }
      if (e.key === 'End')        { e.preventDefault(); this._tabs[count - 1].focus(); }
    }
  }
  if (!customElements.get('pdp-tabs')) { customElements.define('pdp-tabs', PdpTabs); }
  } catch(e) { console.error(e); }
})();

})();
